import { hideCartModal, showCartHoverPreview } from '../utils/utils'

document.addEventListener('DOMContentLoaded', () => {
  const cartIcon = document.querySelector('.logo-bar__links #cart-icon')
  const cartWrapper = document.querySelector('.cart-message-wrapper')
  const cartExitButton = document.querySelector('.cart-message__close')

  if (!cartIcon) return

  let hoverCheckTimeout = null

  const checkHoverState = () => {
    clearTimeout(hoverCheckTimeout)
    hoverCheckTimeout = setTimeout(() => {
      if (!cartIcon.matches(':hover') && !cartWrapper?.matches(':hover')) {
        hideCartModal()
      }
    }, 250)
  }

  cartIcon.addEventListener('mouseenter', showCartHoverPreview)
  cartIcon.addEventListener('mouseleave', checkHoverState)
  cartWrapper?.addEventListener('mouseleave', checkHoverState)
  cartExitButton?.addEventListener('click', hideCartModal)
})
